<template lang="pug">

  div()
    div() {{x}} | {{y}}, {{originX}} | {{originY}}
      div(v-if="$refs.theContainer") percentageX: {{x/$refs.theContainer.getBoundingClientRect().width}}
    #theContainer(ref="theContainer")
      .redBox(ref="redBox"  @mousedown.prevent="startDrag" :style="{top:`${y}px`, left:`${x}px`}" )
    
</template>
<script>
//:style="{top:`${x}px`, left:`${y}px`}"
export default {
  data: () => ({
    isDragging: false,
    x: 0,
    y: 0,
    originX: 0,
    originY: 0
  }),

  methods: {
    startDrag: function(event) {
      this.isDragging = true;
      this.originX = event.clientX - event.target.getBoundingClientRect().x;
      this.originY = event.clientY - event.target.getBoundingClientRect().y;

      window.addEventListener("mouseup", this.stopDrag);
      window.addEventListener("mousemove", this.doDrag);
      console.log(`start drag ${event}`);
    },

    stopDrag: function(event) {
      this.isDragging = false;
      console.log(`stop drag ${event}`);

      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("mousemove", this.doDrag);
    },

    doDrag: function(event) {
      event.preventDefault();
      if (this.isDragging) {
        // this.x =
        //   event.clientX -
        //   (this.$refs.theContainer.getBoundingClientRect().x + 50);
        // this.y =
        //   event.clientY -
        //   this.$refs.theContainer.getBoundingClientRect().y +
        //   40;

        this.x =
          event.clientX -
          this.$refs.theContainer.getBoundingClientRect().x -
          this.originX;
        this.y =
          event.clientY -
          this.$refs.theContainer.getBoundingClientRect().y +
          this.originY;

        // console.log(event.target.getBoundingClientRect());
        console.log(`mouse Move ${event}`);
      }
    }
  }
};
</script>
<style scoped lang="stylus">
#theContainer {
  width: 100%;
  height: 100%;
  background-color: #333333;
}

.redBox {
  width: 100px;
  height: 20px;
  background-color: red;
  // cursor: move;
  position: absolute;
  z-index: 99;
}
</style>
